import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import "./index.css";
import oktaConfig from './app.config';
import App from "./App";
import AuthErrorCallback from "./components/auth/AuthErrorCallback";
import AuthLoadingCallback from "./components/auth/AuthLoadingCallback";

import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";

import { I18nextProvider } from 'react-i18next';
import i18n from './locate/i18n.jsx';
import TransifexWrapper from './locate/TransifexWrapper';

import "bootstrap/dist/css/bootstrap.min.css";
// eslint-disable-next-line
import $ from "jquery";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStar, faBeer, faEnvelope, faLock, faExclamationTriangle, faMobileAlt, faCloud, faChartBar, faUserShield, faGlobe, faBars, faCaretDown } from "@fortawesome/free-solid-svg-icons";

import "bootstrap/dist/js/bootstrap.bundle.min";

import googleServices from './services/googleServices';
import ErrorBoundary from './components/shared/ErrorBoundary';
import store from "./store";
import { FeedsProvider } from "./feedstore.js";

// Initialize Google Services (GA4, GTM, AdSense, Crashlytics) with safeguards
googleServices.initGoogleServices();

library.add(faStar, faBeer, faEnvelope, faLock, faExclamationTriangle, faMobileAlt, faCloud, faChartBar, faUserShield, faGlobe, faBars, faCaretDown);

const oktaAuth = new OktaAuth({
  issuer: oktaConfig.issuer,
  clientId: oktaConfig.client_id,
  redirectUri: oktaConfig.redirect_uri,
  pkce: false, // PKCE is recommended for SPAs
});

const AppWithRouter = () => {
  const navigate = useNavigate();

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true });
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <FeedsProvider>
        {/* The LoginCallback component handles the redirect from Okta */}
        <Routes>
          <Route 
            path={new URL(oktaConfig.redirect_uri).pathname} 
            element={
              <LoginCallback 
                errorComponent={AuthErrorCallback} 
                loadingElement={<AuthLoadingCallback />} 
              />
            } 
          />
          <Route path="/*" element={<App />} />
        </Routes>
      </FeedsProvider>
    </Security>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <I18nextProvider i18n={i18n}>
    <TransifexWrapper>
      <Provider store={store}>
        <Router>
          <ErrorBoundary name="RootAppBoundary">
            <AppWithRouter />
          </ErrorBoundary>
        </Router>
      </Provider>
    </TransifexWrapper>
  </I18nextProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
